import { useEffect } from 'react';

const MicrosoftClarity = ({ trackingId }) => {
  useEffect(() => {
    if (!trackingId) return;

    (function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", trackingId);
    
    // Limpieza opcional si cambia el trackingId
    return () => {
      window.clarity = undefined;
      const scripts = document.querySelectorAll(`script[src*="clarity.ms/tag/${trackingId}"]`);
      scripts.forEach(script => script.remove());
    };
  }, [trackingId]);

  return null;
};

export default MicrosoftClarity;